export default __webpack_public_path__ + "static/services-details2-970da062c7cad3e2c7c04a0155cc317c.png";